import { emailSchema } from '~/utils/validation';
import { z } from 'zod';

export const schema = z.object({
  email: emailSchema,
});

export type Schema = z.infer<typeof schema>;
